/**
 * Chave única para abrir um ticket e rolar até uma mensagem (lista de tickets, drawer do contato).
 * Consumida em MessagesList após o primeiro GET de mensagens.
 */
export const MF_PENDING_TICKET_MESSAGE_SCROLL_KEY =
  "mf_pending_ticket_message_scroll";
